import { TreatmentFilter } from '@src/app/features/search/models/treatment-filter.model';
import { FormStatus } from '@shared/enums/form-status.enum';
import { formStatusToTreatmentStatusMap } from '@src/app/features/search/search.utils';

export function getSurgicalFilters(): TreatmentFilter[] {
  return [
    {
      treatmentType: {
        value: 0,
        label: 'treatment.surgery'
      },
      children: [
        {
          treatmentType: {
            value: 'surgicalInterventionStates',
            label: 'treatment.surgical_intervention'
          },
          treatmentStatuses: [
            formStatusToTreatmentStatusMap.get(FormStatus.SUBMITTED),
            formStatusToTreatmentStatusMap.get(FormStatus.IN_PROGRESS),
            formStatusToTreatmentStatusMap.get(FormStatus.REJECTED),
            formStatusToTreatmentStatusMap.get(FormStatus.EXCEEDS_QUOTA),
            formStatusToTreatmentStatusMap.get(FormStatus.ACCEPTED)
          ]
        }
      ]
    }
  ];
}
